export default {
  config: {
    productName: 'Lucky Six',
  },
  expandTicketHistory: true,
  isFullScreen: false,
  isFreeBetMode: false,
  isBonusMode: false,
  isAudioOn: false,
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  numbersFormat: '0,0.00',
  oddType: 1,
  payinDisabled: true,
  requestDisabled: false,
  streamUuid: null,
  timeToRemoveNotification: 3000,
  ticketsHistory: [],
};
